export default "__VITE_ASSET__BiNRfX7m__"